import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupAssignmentComponent } from '@markant-platform/dashboard/feature-dashboard-group-assignment';
import { Group } from '@markant-platform/authorizer/model';

@Component({
  selector: 'markant-platform-group-assignment-demo',
  standalone: true,
  imports: [CommonModule, GroupAssignmentComponent],
  templateUrl: './group-assignment-demo.component.html',
  styleUrl: './group-assignment-demo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupAssignmentDemoComponent {
  demoGroups: Group[] = [
    {
      id: '1',
      displayName: 'NRW Controlling',
      membersCount: 64,
      organizationId: '1',
      createdAt: '2027-07-27',
      version: 1,
    },
    {
      id: '2',
      displayName: 'ESSEN Einkauf',
      membersCount: 12,
      organizationId: '1',
      createdAt: '2027-07-27',
      version: 1,
    },
    {
      id: '3',
      displayName: 'Temporäre Gruppe WORKSHOP',
      membersCount: 4,
      organizationId: '1',
      createdAt: '2027-07-27',
      version: 1,
    },
    {
      id: '4',
      displayName: 'Dateiaustausch Deutschland',
      membersCount: 2873,
      organizationId: '1',
      createdAt: '2027-07-27',
      version: 1,
    },
    {
      id: '5',
      displayName: 'Vertrieb Nord',
      membersCount: 129,
      organizationId: '1',
      createdAt: '2027-07-27',
      version: 1,
    },
    {
      id: '6',
      displayName: 'Vertrieb Süd',
      membersCount: 89,
      organizationId: '1',
      createdAt: '2027-07-27',
      version: 1,
    },
    {
      id: '7',
      displayName: 'CUSTOM NAME',
      membersCount: 123,
      organizationId: '1',
      createdAt: '2027-07-27',
      version: 1,
    },
    {
      id: '8',
      displayName: 'CUSTOM NAME',
      membersCount: 256,
      organizationId: '1',
      createdAt: '2027-07-27',
      version: 1,
    },
  ];
}
